const Data = [
  {
    name: "Sharanya Baidya",
    position: "School Review Committee Head",
    imageUrl: "/assets/images/members/Heads25/SharanyaBaidya.jpg",
    facebookLink: "https://www.facebook.com/profile.php?id=61554570063765",
    linkedinLink: "https://www.linkedin.com/in/sharanya-baidya-994910297/",
    email: "sharanya.baidya@gyws.org"
  },
  {
    name: "Aaratrika Bhattacharya",
    position: "School Review Committee Head",
    imageUrl: "/assets/images/members/Heads25/AaratrikaBhattacharya.jpg",
    facebookLink: "https://www.facebook.com/share/18uKNsaEmT/",
    linkedinLink: "https://www.linkedin.com/in/aaratrika-bhattacharya-61176a280/",
    email: "aaratrika.bhattacharya@gyws.org"
  },
  {
    name: "Khushi Srivastava",
    position: "School Review Committee Head",
    imageUrl: "/assets/images/members/Heads25/KhushiSrivastava.jpg",
    facebookLink: "https://www.facebook.com/share/4tVqAjjFVomedZLm/?mibextid=qi2Omg",
    linkedinLink: "https://www.linkedin.com/in/khushi-srivastava-7b6b772a6/",
    email: "khushi.srivastava@gyws.org"
  },
  {
    name: "T Sritan Reddy",
    position: "School Review Committee Head",
    imageUrl: "/assets/images/members/Heads25/TSritanReddy.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  }
];

export default Data;